document.addEventListener("DOMContentLoaded", function () {
  const triggerDiv = document.querySelector(".custom-3d-template");
  const socialIconWrapper = document.querySelector(".container-indent.wrapper-social-icon");
  const skuElement = document.querySelector("li.sku-js span:nth-of-type(2)");

  if (triggerDiv && socialIconWrapper && skuElement) {
    const sku = skuElement.textContent.trim();

    if (sku) {
      // Create new div
      const iframeSection = document.createElement("div");
      iframeSection.className = "3d-iframe-section";
      iframeSection.style.padding = "20px";

      // Create and configure iframe
      const iframe = document.createElement("iframe");
      iframe.src = `https://index.hcisolutions.ch/files/articleimages360/${sku}/index.html`;
      iframe.width = "100%";
      iframe.height = "500";
      iframe.style.border = "none";

      // Append iframe to the new div
      iframeSection.appendChild(iframe);

      // Insert the new div after the social icon wrapper
      socialIconWrapper.parentNode.insertBefore(iframeSection, socialIconWrapper.nextSibling);
    } else {
      console.log("SKU is empty. Skipping 3D iframe.");
    }
  }
});
